<template>
    <section class="profile-experience-selector">
        <VJoySelect v-model="model" :label="$t('profile.section.recommendation.ask.experience.label')" type="select">
            <option selected value="">{{ $t('profile.section.recommendation.ask.experience.empty.label') }}</option>
            <option v-for="xp in experiences" :key="`experiences_${xp.id}`" :value="xp.id">{{ xp.company }} - {{ xp.title }}</option>
        </VJoySelect>
    </section>
</template>

<script setup lang="ts">
    import {VJoySelect} from '@maltjoy/core-vue';
    import type {Experience} from '~/types/domain/Experiences';

    const model = defineModel<string | null>({required: true});

    const props = defineProps<{
        experiences: Experience[];
    }>();
</script>
